import { BaseResponseCode } from 'shared/entities/network';
import {
  AIDocErrorCode,
  AIDocErrorResponseCode
} from 'shared/entities/smartbotAI';

/** Friendly toast instead of NetworkErrorMessage for index_site */
export const SITE_SCAN_FRIENDLY_ERROR_CODES: AIDocErrorCode[] = [
  BaseResponseCode.badRequest,
  AIDocErrorResponseCode.externalError,
  AIDocErrorResponseCode.notSupported,
  AIDocErrorResponseCode.internalError
];

export type SiteIndexErrorPayload = {
  code?: string;
  text?: string;
};

const toErrorPayload = (value: unknown): Record<string, unknown> | null => {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }

  return value as Record<string, unknown>;
};

export const parseSiteIndexError = (
  payload:
    | {
        code?: string;
        message?: string;
        data?: unknown;
      }
    | null
    | undefined
): SiteIndexErrorPayload => {
  if (!payload) {
    return {};
  }

  const inner = toErrorPayload(payload.data);
  const fields = toErrorPayload(inner?.fields);
  const urlMessages = (fields?.url as string[] | undefined)?.filter(Boolean);

  return {
    code: payload.code ?? (inner?.code as string | undefined),
    text:
      payload.message ||
      (inner?.text as string | undefined) ||
      (urlMessages?.length ? urlMessages.join(', ') : undefined)
  };
};

export const isFriendlySiteScanError = (code: string | undefined): boolean =>
  code != null &&
  SITE_SCAN_FRIENDLY_ERROR_CODES.includes(code as AIDocErrorCode);
